import React from 'react';
import T from 'prop-types';

import SimpleDropdown from '../../../Dropdowns/SimpleDropdown';
import { panelsVersionsOptions, panelsVersionsFor } from '../../configs/report';

const PanelVersionDropdown = ({
  panelVersion,
  disabled = false,
  showOnlyPublicPanels = true,
  allowedDatasets = ['US'],
  onChange,
}) => {
  const options = (showOnlyPublicPanels
    ? panelsVersionsFor(allowedDatasets)
    : panelsVersionsOptions).map(option => ({
    ...option,
    className: 'menu-item--14',
  }));

  return (
    <section className="upsert-export-form__panel-region">
      {disabled && <div className="disabled-block" />}
      <h4 className="h5">Panel Region</h4>
      <SimpleDropdown
        selected={panelVersion}
        variant="light"
        options={options}
        disabled={options.length === 1}
        onChange={onChange}
      />
    </section>
  );
};

PanelVersionDropdown.propTypes = {
  panelVersion: T.string.isRequired,
  disabled: T.bool,
  showOnlyPublicPanels: T.bool,
  allowedDatasets: T.arrayOf(T.string),
  onChange: T.func.isRequired,
};

export default PanelVersionDropdown;
